<div #wrapper id="wrapper" [@dialog]="state">
  <app-commentpagetemplate
    #commentpage
    [isReplies]="isReplies"
    [originalComment]="originalComment"
    [post]="post"
    [openKeyboardAlready]="openKeyboardAlready"
  />
</div>
